import { createContext, useContext } from 'react'
import { noop } from '@manychat/manyui'

import { FilterSource } from 'common/filter/constants'
import { getDefaultFilter } from 'common/filter/models/AudienceFilter/defaults'

import { defaultFilterConfig } from './constants'
import { FilterContextValue } from './types'

export const FilterContext = createContext<FilterContextValue>({
  source: FilterSource.TEST,
  isBuilder: false,
  fields: [],
  config: defaultFilterConfig,
  value: getDefaultFilter(),
  changeOperator: noop,
  createCondition: noop,
  changeCondition: noop,
  removeCondition: noop,
})

export const useFilterContext = () => useContext(FilterContext)
